import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'hours'
})
export class HoursPipe implements PipeTransform {

  transform(value: any, haveTwoZero: boolean = false, showAbr: boolean = false): string {
    var sec_num = parseInt(value, 10); // don't forget the second param
    var hours = Math.floor(sec_num / 3600);

    return haveTwoZero ? (hours > 9 ? `${hours}` : `0${hours}`) : (`${hours}`);
  }

}
